<template>
  <div class="chart-container">
    <div class="chart-header">
      <div class="chart-title">{{ chartTitle }}</div>
      <div class="chart-switch">
        <span class="switch-text" @click="toggleChartType">切换</span>
      </div>
    </div>
    <div id="lineChart" style="width: 100%; height: calc(100% - 20px)"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "PaymentRecordsChart",
  props: {
    chartData: {
      type: Array,
      default: () => [],
    },
    orderData: {
      type: Array,
      default: () => [],
    },
    defaultType: {
      type: String,
      default: 'payment'
    }
  },
  data() {
    return {
      chartInstance: null,
      chartType: this.defaultType, // 'payment' 或 'order'
    };
  },
  computed: {
    chartTitle() {
      return this.chartType === 'payment' ? '每月自主缴费记录统计' : '工单/故障统计类型';
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
      this.updateChart();
    });
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  },
  watch: {
    chartData: {
      handler() {
        this.updateChart();
      },
      deep: true,
    },
    orderData: {
      handler() {
        this.updateChart();
      },
      deep: true,
    },
    chartType() {
      this.updateChart();
    }
  },
  methods: {
    initChart() {
      const chartDom = document.getElementById("lineChart");
      if (chartDom) {
        this.chartInstance = echarts.init(chartDom);
      }
    },
    toggleChartType() {
      // 在两种类型间切换
      const newType = this.chartType === 'payment' ? 'order' : 'payment';
      this.chartType = newType;
      this.$emit('chart-type-change', newType);
    },
    updateChart() {
      if (!this.chartInstance) return;

      let currentData = [];
      let yAxisName = '';
      let lineColor = '#00d4ff';

      if (this.chartType === 'payment') {
        currentData = this.chartData;
        yAxisName = '缴费数量';
        lineColor = '#00d4ff';
      } else {
        currentData = this.orderData;
        yAxisName = '工单/故障数量';
        lineColor = '#ffaa00';
      }

      if (!currentData.length) return;

      const option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          borderColor: lineColor,
          textStyle: { color: "#fff" },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "40px",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: currentData.map((item) => item.name),
          axisLine: { lineStyle: { color: lineColor } },
          axisLabel: { color: "#fff", fontSize: 10 },
        },
        yAxis: {
          type: "value",
          name: yAxisName,
          axisLine: { lineStyle: { color: lineColor } },
          axisLabel: { color: "#fff" },
          splitLine: { lineStyle: { color: `rgba(${this.hexToRgb(lineColor)}, 0.2)` } },
        },
        series: [
          {
            data: currentData.map((item) => item.value),
            type: "line",
            smooth: true,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: `${lineColor}66` },
                { offset: 1, color: `${lineColor}1A` },
              ]),
            },
            lineStyle: {
              color: lineColor,
              width: 2,
            },
            itemStyle: {
              color: lineColor,
              borderColor: "#fff",
              borderWidth: 2,
            },
          },
        ],
      };
      this.chartInstance.setOption(option);
    },
    hexToRgb(hex) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ?
        `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}` :
        '0, 212, 255';
    }
  },
};
</script>

<style scoped>
.chart-container {
  background: rgba(10, 25, 41, 0.8);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.2);
  box-sizing: border-box;
  height: 100%;
}

.chart-header {
  position: relative;
  margin-bottom: 10px;
}

.chart-title {
  font-size: 16px;
  color: #00d4ff;
  font-weight: bold;
  text-align: center;
  flex: 1;
  margin-top: 10px;
}

.chart-switch {
  position: absolute;
  right: 0;
  top: 0;
}

.switch-text {
  color: #00d4ff;
  font-size: 12px;
  cursor: pointer;
  text-decoration: underline;
  transition: color 0.3s;
}

.switch-text:hover {
  color: #88c4ff;
}
</style>
